import { useEffect, useState } from "react";
import axios from "axios";

// Fetches the conversation list (server-filtered by type, the only filter
// the backend supports) plus the small lookup lists the filter bar needs.
export default function useConversationsList(conversationType) {
    const [conversations, setConversations] = useState([]);
    const [conversationTypes, setConversationTypes] = useState([]);
    const [levels, setLevels] = useState([]);
    const [usedConversationIds, setUsedConversationIds] = useState(new Set());

    useEffect(() => {
        axios
            .get("/api/conversationtypes", { withCredentials: true })
            .then((response) => setConversationTypes(response.data))
            .catch((err) => console.error(err));
        axios
            .get("/api/levels", { withCredentials: true })
            .then((response) => setLevels(response.data))
            .catch((err) => console.error(err));

        // One-off fetch of every progress record so tiles can show whether a
        // template has ever actually been taken, without an N+1 request per tile.
        axios
            .get("/api/conversationprogress", { withCredentials: true })
            .then((response) => {
                const ids = (response.data || []).map((progress) => progress.conversationId?.id).filter((id) => id != null);
                setUsedConversationIds(new Set(ids));
            })
            .catch((err) => console.error(err));
    }, []);

    useEffect(() => {
        const url = conversationType === "" || conversationType == null ? "/api/conversations" : "/api/conversations?type=" + conversationType;
        axios
            .get(url, { withCredentials: true })
            .then((response) => setConversations(response.data))
            .catch((err) => console.error(err));
    }, [conversationType]);

    return { conversations, conversationTypes, levels, usedConversationIds };
}
